import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Inward from "@/pages/Inward";
import QC from "@/pages/QC";
import Stock from "@/pages/Stock";
import Mixing from "@/pages/Mixing";
import Dispatch from "@/pages/Dispatch";
import Transfer from "@/pages/Transfer";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Trash from "@/pages/Trash";
import InstallPrompt from "@/components/InstallPrompt";

// Role groups
const LOCATION_USERS = ["store_manager", "factory_user", "baikampady_user", "maghveera_user"];
const ROLES_INWARD = [...LOCATION_USERS, "super_admin"];
const ROLES_QC_ONLY = ["qc_manager", "super_admin"];
const ROLES_STOCK_VIEW = [...LOCATION_USERS, "qc_manager", "top_management", "super_admin"];
const ROLES_DISPATCH = [...LOCATION_USERS, "qc_manager", "top_management", "super_admin"];
const ROLES_MIX_TRANSFER = [...LOCATION_USERS, "qc_manager", "top_management", "super_admin"];
const ROLES_ADMIN = ["top_management", "super_admin"];

const Protected = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8" style={{ color: "var(--text-muted)" }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/inward" element={<Protected roles={ROLES_INWARD}><Inward /></Protected>} />
            <Route path="/qc" element={<Protected roles={ROLES_QC_ONLY}><QC /></Protected>} />
            <Route path="/stock" element={<Protected roles={ROLES_STOCK_VIEW}><Stock /></Protected>} />
            <Route path="/mixing" element={<Protected roles={ROLES_MIX_TRANSFER}><Mixing /></Protected>} />
            <Route path="/transfer" element={<Protected roles={ROLES_MIX_TRANSFER}><Transfer /></Protected>} />
            <Route path="/dispatch" element={<Protected roles={ROLES_DISPATCH}><Dispatch /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/users" element={<Protected roles={ROLES_ADMIN}><Users /></Protected>} />
            <Route path="/trash" element={<Protected><Trash /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallPrompt />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
